import { observer } from 'mobx-react';

import type { BingoWidgetDataType, WidgetSizeType } from '../../types';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { BingoSmallWidget } from './BingoSmallWidget/BingoSmallWidget';
import { BingoWideWidget } from './BingoWideWidget/BingoWideWidget';
import styles from './BingoWidget.module.scss';

interface BingoWidgetProps {
  sizeType: WidgetSizeType;
  data: BingoWidgetDataType;
}

function BingoWidgetComponent(props: BingoWidgetProps) {
  const { data, sizeType } = props;
  const { widgetType } = data;
  const timerIncluded = widgetType === 'upcoming';

  return (
    <WidgetWrapper className={styles.container} sizeType={sizeType} smallWidgetExtended={timerIncluded}>
      {sizeType === 'small' ? (
        <BingoSmallWidget data={data} />
      ) : (
        <BingoWideWidget data={data} widgetType={widgetType} />
      )}
    </WidgetWrapper>
  );
}

export const BingoWidget = observer(BingoWidgetComponent);
